<template>
  <div class="flex flex-col gap-10 relative">
    <!-- Weaknesses section skeleton -->
    <ContentRowSkeleton :count="5" />

    <!-- Strengths section skeleton -->
    <ContentRowSkeleton :count="5" />
  </div>
</template>

<script setup>
import ContentRowSkeleton from './ContentRowSkeleton.vue';
</script>
